import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { EventProfileCreate } from './EventProfileCreate';
import { EventProfileDisplay } from './EventProfileDisplay';
import { EventProfileSearch } from './EventProfileSearch';
import { EventProfileUpdate } from './EventProfileUpdate';
import { Four04 } from 'gossamer-front-end';
import { BookingPaymentTermsDisplay } from './BookingPaymentTermsDisplay';
import { BookingPaymentTermsUpsert } from './BookingPaymentTermsUpsert';

export const EventProfileRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/create" element={<EventProfileCreate />} />
    <Route path="/display/:key" element={<EventProfileDisplay />} />
    <Route path="/display-payment-terms/:key" element={<BookingPaymentTermsDisplay />} />
    <Route path="/search" element={<EventProfileSearch />} />
    <Route path="/update/:key" element={<EventProfileUpdate />} />
    <Route path="/update-payment-terms/:key" element={<BookingPaymentTermsUpsert />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
